import Swiper from 'swiper/bundle';

export default Array.from(document.querySelectorAll('.slider')).map((sliderEl) => {
  const items = sliderEl.querySelector('.slider__items');
  if (!items) return null;

  const swiperContainer = document.createElement('div');
  swiperContainer.classList.add('swiper');
  items.parentNode.insertBefore(swiperContainer, items);
  swiperContainer.appendChild(items);

  items.classList.add('swiper-wrapper');
  const slides = Array.from(items.children).map((child) => {
    child.classList.add('swiper-slide');
    return child;
  });

  const paginationEl = sliderEl.querySelector('.swiper-pagination');
  const prevEl = sliderEl.querySelector('.slider__prev');
  const nextEl = sliderEl.querySelector('.slider__next');

  const setSlidesEqualHeight = () => {

    slides.forEach((slide) => {
      slide.style.height = '';
    });
    // Find tallest slide
    let maxHeight = 0;
    slides.forEach((slide) => {
      const h = slide.scrollHeight;
      if (h > maxHeight) {
        maxHeight = h;
      }
    });

    slides.forEach((slide) => {
      slide.style.height = `${maxHeight}px`;
    });
  };

  const swiper = new Swiper(swiperContainer, {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    speed: 600,
    navigation: {
      prevEl,
      nextEl,
    },
    pagination: {
      el: paginationEl,
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
    on: {
      init() {
        items.style.visibility = 'visible';
        setSlidesEqualHeight();
      },
      resize() {
        setSlidesEqualHeight();
      },
    },
  });

  swiper.init();
  return swiper;
});
